import { render, staticRenderFns } from "./EtiquetasModalNuevo.vue?vue&type=template&id=d6ad9716&scoped=true&"
import script from "./EtiquetasModalNuevo.vue?vue&type=script&lang=ts&"
export * from "./EtiquetasModalNuevo.vue?vue&type=script&lang=ts&"
import style0 from "./EtiquetasModalNuevo.vue?vue&type=style&index=0&id=d6ad9716&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6ad9716",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('d6ad9716', component.options)
    } else {
      api.reload('d6ad9716', component.options)
    }
    module.hot.accept("./EtiquetasModalNuevo.vue?vue&type=template&id=d6ad9716&scoped=true&", function () {
      api.rerender('d6ad9716', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/plataforma/EtiquetasModalNuevo.vue"
export default component.exports